import { render } from "./AdminTrackApprovedLiquidation.vue?vue&type=template&id=9b63cbee"
import script from "./AdminTrackApprovedLiquidation.vue?vue&type=script&lang=js"
export * from "./AdminTrackApprovedLiquidation.vue?vue&type=script&lang=js"

import "./AdminTrackApprovedLiquidation.vue?vue&type=style&index=0&id=9b63cbee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__